import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  listboxStyle: {
    fontSize: "1.2rem",
    fontWeight: "900",
    fontFamily: "'Open Sans', sans-serif",
  },
  muifab: {
    color: "#fff",
    backgroundColor: "#3f51b5",
    borderRadius: "50%",
    zIndex: "1",
    cursor: "pointer",
    float: "right",
    marginTop: "2rem !important",
  },
  deleteIcon: {
    color: "#f50057",
    cursor: "pointer",
  },
  tableHead: {
    color: "#fff !important",
    backgroundColor: "#1976d2 !important",
    padding: "1rem !important",
  },
  toolTip: {
    fontSize: "1rem",
  },
}));

export const customMenuListStyles = {
  control: (base, state) => ({
    ...base,
    fontSize: "1.2rem !important",
    color: "#000",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1.2rem !important",

  }),
};
